import { Fancybox } from '@fancyapps/ui';

export class Modal {

    constructor ( target = '.js-modal', options = {} ) {
        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        Fancybox.bind(this.target, this.options);
    }

}
